var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-10" }, [
    _c(
      "div",
      { staticClass: "p-20 bg-white" },
      [
        _vm.type == 1
          ? _c(
              "div",
              { staticClass: "mb-20 flex align-center" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.ejectEquip()
                      },
                    },
                  },
                  [_vm._v("全部弹出")]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "el-table",
          { attrs: { data: _vm.baoList } },
          [
            _c("el-table-column", { attrs: { label: "序列号", prop: "sn" } }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "卡槽位置" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.baoList.length == 6 && row.aims == 1
                              ? _vm.getNoTextZCM(row.no)
                              : _vm.getNoText(row.aims, row.no)
                          ) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "电量" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.getPowerText(row)) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "状态" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.getStatusText(row.status)) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "操作" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm.type == 1
                        ? _c(
                            "div",
                            [
                              scope.row.bind_action != 0
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        size: "small",
                                        plain: "",
                                        round: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.ejectEquip(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("弹出\n            ")]
                                  )
                                : _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "danger",
                                        size: "small",
                                        plain: "",
                                        round: "",
                                      },
                                    },
                                    [_vm._v("非本人不可弹出")]
                                  ),
                              _vm._v(" "),
                              scope.row.bao_sn && scope.row.bind_action != 0
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type:
                                          scope.row.is_locked == 1
                                            ? "danger"
                                            : "warning",
                                        size: "small",
                                        plain: "",
                                        round: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.locked(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            scope.row.is_locked == 1
                                              ? "解锁"
                                              : "锁定"
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.type == 2
                        ? _c(
                            "div",
                            [
                              scope.row.bao_sn && scope.row.bind_action == 1
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type:
                                          scope.row.binded_status == 1
                                            ? "primary"
                                            : "danger",
                                        size: "small",
                                        plain: "",
                                        round: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.binded(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            scope.row.binded_status == 1
                                              ? "解绑"
                                              : "绑定"
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "danger",
                                        size: "small",
                                        plain: "",
                                        round: "",
                                      },
                                    },
                                    [_vm._v("非本人设备")]
                                  ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }